var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 285,
    viewBox: "0 0 230 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.566 129.4C220.025 80.8512 189.958 32.2059 141.409 20.7475C92.8606 9.28898 44.2154 39.3563 32.7569 87.9048C21.2985 136.453 51.3658 185.099 99.9143 196.557C148.463 208.015 197.108 177.948 208.566 129.4Z",
    fill: "url(#paint0_radial_1023_10279)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.674 102.998C183.314 101.278 181.374 96.6181 182.704 93.2681C186.064 82.9481 191.544 71.1481 182.104 64.2681C173.714 58.5881 163.174 58.2581 155.054 51.9081C149.294 47.2781 148.564 37.6581 144.524 30.5981C139.324 20.7481 126.794 23.5181 116.794 21.8481C113.424 21.4081 110.314 20.5981 107.554 19.3181C122.814 16.7881 138.874 18.2481 154.194 24.3781C199.704 42.5581 221.564 94.9481 203.004 141.398C200.824 146.848 198.184 151.968 195.144 156.738C200.554 138.878 200.894 116.308 185.664 102.988L185.674 102.998Z",
    fill: "#FF584F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.654 96.8981C125.724 106.248 136.914 106.838 145.474 106.368C149.954 106.598 153.084 110.188 156.224 113.768C165.244 123.588 150.434 133.988 150.884 144.278C151.634 150.018 157.334 157.358 157.474 164.008C157.844 182.318 148.424 185.088 144.924 194.978C127.704 200.208 108.884 200.238 90.8844 194.008C91.5244 190.988 91.5644 187.678 90.8344 184.018C90.0844 178.278 84.5644 176.848 79.3044 174.748C81.0344 172.328 78.1344 171.948 77.7444 171.018C80.5644 162.038 85.9244 148.638 79.1144 142.808C73.6144 137.498 64.1344 138.378 57.7044 133.478C49.5844 127.128 51.1144 113.748 44.7244 104.978C41.7644 100.858 37.6744 96.2781 32.6544 95.7181C33.7044 88.9481 35.5244 82.1881 38.1844 75.5481C42.4744 64.8181 48.5444 55.3481 55.8944 47.3481C63.9044 47.5981 71.3444 51.5681 75.4444 60.5081C76.8744 62.6381 80.5744 61.0081 81.7744 59.9281C93.9444 52.3581 110.164 47.9581 116.004 61.9481C121.334 73.3981 125.344 84.3281 125.654 96.8881V96.8981Z",
    fill: "#F9AC4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.934 194.988C147.534 187.628 154.924 179.088 154.894 171.418C154.874 164.328 149.524 158.078 148.044 151.298C146.324 143.458 151.724 137.068 150.304 129.348C148.494 119.568 138.034 120.638 132.114 115.118C123.684 107.258 125.704 94.2381 115.924 88.2381C108.864 83.9081 106.794 82.1481 105.344 73.3681C103.904 64.6181 98.5844 60.4881 89.8744 61.0581C83.0644 61.5081 77.0144 65.9881 72.6644 60.3681C70.1344 57.0981 69.0344 51.4781 65.2244 49.5981C63.9744 48.9781 57.0744 46.0781 55.9044 47.3481C69.6744 32.3881 87.9544 22.5681 107.544 19.3281C110.314 20.5981 113.414 21.4181 116.784 21.8581C126.784 23.5181 139.314 20.7581 144.514 30.6081C148.554 37.6581 149.274 47.2781 155.044 51.9181C163.164 58.2681 173.704 58.5981 182.094 64.2781C191.534 71.1581 186.054 82.9581 182.694 93.2781C181.354 96.6281 183.304 101.288 185.664 103.008C200.894 116.328 200.554 138.888 195.144 156.758C183.214 175.528 165.174 188.858 144.934 194.998V194.988Z",
    fill: "#FF7D4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7244 133.488C64.1444 138.388 73.6344 137.508 79.1344 142.818C85.9444 148.648 80.5944 162.048 77.7644 171.028C78.1544 171.958 81.0444 172.338 79.3244 174.758C84.5744 176.858 90.1044 178.288 90.8544 184.028C91.5944 187.688 91.5444 190.998 90.9044 194.018C89.6044 193.568 88.3044 193.088 87.0044 192.568C47.9944 176.988 26.3644 136.278 32.6644 95.7183C37.6844 96.2883 41.7744 100.858 44.7344 104.978C51.1344 113.748 49.5944 127.128 57.7144 133.478L57.7244 133.488Z",
    fill: "#FED996"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1023_10279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3315 268.029C34.9794 257.79 58.0753 231.852 58.0753 231.852L56.3444 230.233C56.3444 230.233 28.5422 262.052 28.6765 269.243L31.3315 268.029Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8748 254.909C28.7838 247.271 51.1517 225.376 51.1517 225.376L52.8826 226.995C52.8826 226.995 24.0443 255.969 16.8412 257.639L17.8748 254.909Z",
    fill: "#F3E600",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3932 226.537L56.1764 230.076C56.1764 230.076 28.6347 258.469 28.8037 266.486C28.9727 274.504 25.1436 259.859 25.1436 259.859L17.5898 257.6C17.5898 257.6 34.7246 246.146 39.6331 241.234C47.9505 232.898 52.4005 226.544 52.4005 226.544L52.3932 226.537Z",
    fill: "#C80923",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7753 230.636C56.7753 230.636 31.5707 257.409 28.7008 269.334L26.2716 269.472C26.2716 269.472 27.0776 261.627 55.3434 229.283L56.7822 230.629L56.7753 230.636Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3129 226.462C52.3129 226.462 27.3067 253.243 16.9641 257.083L16.2752 259.123C16.2752 259.123 34.9083 248.467 53.7517 227.808L52.3129 226.462Z",
    fill: "#F54E1D",
    stroke: "#3F3D56",
    strokeWidth: 0.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M46.5118 240.863C48.6523 239.497 50.5847 238.675 52.2452 238.188C55.5892 234.305 57.9215 231.694 57.9215 231.694L50.9979 225.219C50.9979 225.219 36.6319 239.92 25.5384 249.233C27.7316 250.08 29.7196 251.98 33.1271 251.689C38.1577 251.274 39.2242 245.507 46.5114 240.849L46.5118 240.863Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4731 240.649L58.1196 241.218C56.3682 241.949 54.3639 241.676 52.8743 240.502C50.382 238.54 46.4591 235.268 43.3709 231.778C42.0916 230.335 41.7053 228.303 42.3734 226.491L42.8798 225.129L59.4731 240.649Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M54.1714 238.881C51.6791 236.919 47.7563 233.647 44.6681 230.156C43.5723 228.913 43.1276 227.251 43.4495 225.662L42.7629 225.02L42.2566 226.381C41.5885 228.194 41.9748 230.225 43.2541 231.668C46.3496 235.166 50.2651 238.431 52.7575 240.392C54.2471 241.567 56.2514 241.839 58.0028 241.108L59.3563 240.54L58.626 239.857C57.0889 240.226 55.4429 239.878 54.1787 238.887L54.1714 238.881Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0828 240.127L62.0454 240.768C60.5121 241.251 58.832 240.939 57.5815 239.934C54.4337 237.414 48.2836 232.278 43.7384 227.11C42.6719 225.893 42.2833 224.215 42.7123 222.659L43.2676 220.645L64.0969 240.127L64.0828 240.127Z",
    fill: "#00FF9F",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9763 220.203L87.1045 229.537C87.1553 233.172 85.8932 236.688 83.5451 239.462C79.1958 244.596 71.7229 253.01 65.4033 258.039C63.7424 259.361 61.3182 257.957 61.644 255.852L64.0964 240.113L86.9763 220.203Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M64.1852 240.018L61.7329 255.757C61.4071 257.862 63.8312 259.266 65.4921 257.944C66.7877 256.911 68.135 255.734 69.4868 254.479C68.1168 254.553 66.8036 253.366 67.0547 251.779L69.5071 236.04L64.1852 240.018Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6425 231.454C57.5358 236.03 63.9131 240.133 63.9131 240.133C63.9131 240.133 103.81 207.563 109.256 196.938C114.695 186.306 111.114 168.936 111.114 168.936C111.114 168.936 93.5301 166.525 83.2928 172.668C73.0555 178.812 43.0856 220.283 43.0856 220.283C43.0856 220.283 47.7424 226.884 52.6283 231.454L52.6425 231.454Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.905 170.229C108.937 177.032 106.563 183.684 102.789 189.506C98.8836 195.233 93.7403 199.897 89.0047 204.902C79.2832 214.623 69.3932 224.172 59.2097 233.406C68.8509 223.61 78.6829 214.02 88.3313 204.231C93.0776 199.332 98.2058 194.64 102.181 189.102C106.032 183.461 108.566 176.931 109.906 170.243L109.905 170.229Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3268 199.267C76.9276 204.903 83.2579 209.714 89.3501 214.81C82.6302 210.619 76.1105 205.644 71.3268 199.267Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9209 201.2C89.9209 201.2 88.7275 203.808 78.2315 200.098C67.7355 196.387 67.3438 204.141 67.3438 204.141C67.3438 204.141 75.3055 200.825 77.0254 202.324C77.0254 202.324 71.2424 205.418 68.1433 209.01C65.0443 212.601 51.5323 230.415 51.5323 230.415L42.9895 220.371C42.9895 220.371 47.0345 218.198 50.4819 213.81C60.4306 201.153 79.9253 175.639 83.9902 174.06C89.4592 171.946 102.82 167.601 109.692 169.154C109.692 169.154 90.38 177.9 86.6074 182.929C82.8347 187.959 89.9209 201.2 89.9209 201.2Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.973 169.485C106.973 169.485 94.6874 170.88 86.5234 177.881C78.3595 184.882 67.1444 198.601 67.1444 198.601C67.1444 198.601 83.6396 180.291 87.3656 178.313C91.0917 176.334 100.385 170.937 106.973 169.485Z",
    fill: "#A6A5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1096 224.892C85.9234 230.185 85.202 236.754 80.6916 240.244C84.2924 235.999 84.7643 230.224 85.1096 224.892Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4065 243.675C63.5714 243.455 63.83 240.397 64.5842 239.679L72.234 233.169L86.9691 220.196C86.9691 220.196 73.2941 233.982 69.1767 240.127C68.1726 241.625 66.7254 242.777 65.035 243.428L64.3992 243.668L64.4065 243.675Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.574 171.607C110.574 171.607 111.677 188.727 105.683 197.347C99.6882 205.967 80.2924 224.494 80.2924 224.494C80.2924 224.494 96.3348 212.744 104.838 200.856C113.341 188.969 110.993 182.666 110.581 171.614L110.574 171.607Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M81.9445 200.9C85.8409 204.544 91.9539 204.34 95.5982 200.444C99.2425 196.547 99.0381 190.434 95.1416 186.79C91.2452 183.146 85.1323 183.35 81.488 187.247C77.8437 191.143 78.0481 197.256 81.9445 200.9Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8652 214.422C56.5791 215.09 57.6992 215.053 58.367 214.339C59.0347 213.625 58.9972 212.505 58.2833 211.837C57.5694 211.169 56.4493 211.207 55.7815 211.921C55.1138 212.635 55.1513 213.755 55.8652 214.422Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8361 209.958C59.1911 210.29 59.7479 210.271 60.0799 209.916C60.4119 209.561 60.3933 209.004 60.0383 208.672C59.6834 208.34 59.1265 208.359 58.7945 208.714C58.4625 209.069 58.4812 209.626 58.8361 209.958Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4949 207.864C56.7491 208.102 57.1477 208.089 57.3854 207.834C57.6231 207.58 57.6097 207.182 57.3556 206.944C57.1015 206.706 56.7028 206.72 56.4652 206.974C56.2275 207.228 56.2408 207.627 56.4949 207.864Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6827 199.036C64.9167 199.255 65.2837 199.243 65.5025 199.009C65.7213 198.775 65.7091 198.408 65.4751 198.189C65.2412 197.97 64.8741 197.983 64.6553 198.217C64.4365 198.451 64.4488 198.818 64.6827 199.036Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7149 195.912C67.0054 196.184 67.461 196.169 67.7326 195.878C68.0042 195.588 67.989 195.132 67.6986 194.86C67.4082 194.589 66.9525 194.604 66.6809 194.894C66.4093 195.185 66.4245 195.641 66.7149 195.912Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4389 214.63C82.9471 215.106 83.7444 215.079 84.2198 214.571C84.6951 214.063 84.6684 213.265 84.1602 212.79C83.652 212.315 82.8546 212.341 82.3793 212.849C81.904 213.358 81.9306 214.155 82.4389 214.63Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.253 216.968C80.5071 217.205 80.9058 217.192 81.1435 216.938C81.3811 216.684 81.3678 216.285 81.1137 216.048C80.8596 215.81 80.4609 215.823 80.2232 216.077C79.9856 216.331 79.9989 216.73 80.253 216.968Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M71.3268 199.267C71.3268 199.267 73.0378 204.523 72.8807 207.019C72.7236 209.514 72.7059 209.197 74.9147 212.837C77.1236 216.478 78.4719 218.081 82.0339 216.908C85.5959 215.735 89.3501 214.81 89.3501 214.81L79.5665 207.439L71.3268 199.267Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6061 246.342C72.1587 246.859 73.0256 246.83 73.5425 246.277C74.0593 245.725 74.0303 244.858 73.4777 244.341C72.9251 243.824 72.0582 243.853 71.5414 244.406C71.0245 244.958 71.0535 245.825 71.6061 246.342Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3121 244.752C74.5057 244.933 74.8095 244.923 74.9906 244.729C75.1716 244.535 75.1615 244.232 74.9679 244.051C74.7743 243.869 74.4705 243.88 74.2894 244.073C74.1083 244.267 74.1185 244.571 74.3121 244.752Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3195 196.206L51.997 196.702C48.3669 196.894 44.943 198.388 42.3319 200.916C37.5006 205.599 29.6041 213.617 25.0081 220.258C23.8 222.004 25.3635 224.329 27.4422 223.863L42.9822 220.365L61.3195 196.206Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7652 198.382C51.4682 199.082 45.7305 199.932 41.7427 203.815C44.9238 199.082 51.4295 197.923 56.7652 198.382Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4426 212.614C38.9952 213.131 39.8622 213.102 40.379 212.549C40.8959 211.996 40.8669 211.129 40.3143 210.613C39.7617 210.096 38.8947 210.125 38.3779 210.677C37.8611 211.23 37.89 212.097 38.4426 212.614Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8561 209.814C40.0497 209.995 40.3534 209.985 40.5345 209.791C40.7156 209.598 40.7054 209.294 40.5118 209.113C40.3182 208.932 40.0145 208.942 39.8334 209.136C39.6523 209.329 39.6624 209.633 39.8561 209.814Z",
    fill: "#BD00FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M42.9614 220.167L27.4214 223.666C25.3427 224.131 23.7793 221.806 24.9873 220.061C25.9323 218.699 27.0167 217.276 28.1786 215.844C28.1962 217.215 29.4684 218.446 31.0342 218.09L46.5743 214.592L42.9614 220.167Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M98.2489 182.809C93.7109 178.277 89.8145 173.469 87.9732 170.665C87.398 170.812 86.83 170.965 86.2703 171.154C87.6053 173.415 90.7787 177.972 94.9294 182.347C95.5526 182.998 96.183 183.656 96.8344 184.307C101.123 188.578 106.182 192.392 110.439 194.224C110.583 193.674 110.706 193.118 110.815 192.563C106.766 190.597 102.246 186.807 98.2348 182.809L98.2489 182.809Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7856 177.492C99.1769 177.858 99.7907 177.837 100.157 177.446C100.523 177.055 100.502 176.441 100.111 176.075C99.7195 175.709 99.1057 175.73 98.7398 176.121C98.3738 176.512 98.3943 177.126 98.7856 177.492Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0725 177.185C99.2944 177.393 99.6424 177.381 99.8499 177.159C100.057 176.938 100.046 176.59 99.8239 176.382C99.6021 176.175 99.254 176.186 99.0465 176.408C98.8391 176.63 98.8507 176.978 99.0725 177.185Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4194 173.303C95.8106 173.669 96.4245 173.649 96.7904 173.257C97.1563 172.866 97.1358 172.252 96.7446 171.886C96.3533 171.52 95.7395 171.541 95.3735 171.932C95.0076 172.323 95.0281 172.937 95.4194 173.303Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7063 172.996C95.9282 173.204 96.2762 173.192 96.4837 172.97C96.6912 172.749 96.6796 172.401 96.4577 172.193C96.2359 171.986 95.8878 171.997 95.6803 172.219C95.4728 172.441 95.4845 172.789 95.7063 172.996Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.737 181.407C103.128 181.773 103.742 181.752 104.108 181.361C104.474 180.97 104.453 180.356 104.062 179.99C103.671 179.624 103.057 179.644 102.691 180.036C102.325 180.427 102.346 181.041 102.737 181.407Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.024 181.1C103.246 181.307 103.594 181.296 103.801 181.074C104.009 180.852 103.997 180.504 103.775 180.297C103.553 180.089 103.205 180.101 102.998 180.323C102.79 180.544 102.802 180.892 103.024 181.1Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.182 185.057C107.573 185.423 108.187 185.403 108.553 185.012C108.919 184.62 108.898 184.007 108.507 183.641C108.116 183.275 107.502 183.295 107.136 183.686C106.77 184.078 106.791 184.692 107.182 185.057Z",
    fill: "#A6A5AE",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.469 184.751C107.691 184.958 108.039 184.947 108.246 184.725C108.454 184.503 108.442 184.155 108.22 183.947C107.998 183.74 107.65 183.752 107.443 183.973C107.235 184.195 107.247 184.543 107.469 184.751Z",
    fill: "#04DAF6",
    stroke: "#3F3D56",
    strokeWidth: 0.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5842 239.679C64.5842 239.679 52.35 232.015 47.6248 224.638",
    stroke: "#3F3D56",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M49.428 233.075L57.027 239.648C57.1941 239.777 57.347 239.906 57.4994 240.022C58.6554 240.952 60.1664 241.284 61.5987 240.953C60.3044 238.428 58.0911 235.29 54.5484 233.441C52.6044 232.431 49.2514 231.39 46.1148 229.839C47.199 230.949 48.3106 232.03 49.4275 233.061L49.428 233.075Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4565 244.278C40.4565 244.278 51.0667 238.497 63.8335 224.846C75.5689 212.299 74.939 208.273 74.7642 207.699C74.7486 207.657 74.7189 207.616 74.6897 207.588C74.6897 207.588 74.6172 207.534 74.5743 207.521C73.9964 207.378 69.9307 207.026 58.1953 219.573C45.4285 233.223 40.3688 244.196 40.3688 244.196L40.4638 244.285L40.4565 244.278Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4011 227.274C55.9497 226.893 54.1573 227.668 52.7793 228.35C52.2921 228.593 51.8186 227.972 52.1943 227.57C53.1642 226.533 54.8989 225.513 57.7371 226.182C60.5325 226.839 59.5427 224.955 59.9549 224.587L60.0847 224.448C60.0847 224.448 60.5701 223.944 61.4393 223.703C62.1472 223.502 62.5754 222.766 62.3958 222.05C62.0192 220.521 61.7339 217.912 63.3775 215.862C65.1846 213.623 71.4989 209.492 74.8181 207.407C74.8181 207.407 74.7456 207.353 74.7027 207.34C74.1248 207.197 70.0591 206.845 58.3237 219.392C45.5569 233.042 40.4972 244.015 40.4972 244.015L40.5922 244.104C40.5922 244.104 40.7521 244.02 41.0574 243.84C42.9401 241.535 49.3709 233.693 51.0616 231.783C53.0524 229.537 56.4015 227.288 56.4015 227.288L56.4011 227.274Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2231 221.048C64.8604 221.644 65.8602 221.611 66.4563 220.974C67.0523 220.336 67.0189 219.336 66.3816 218.74C65.7443 218.144 64.7445 218.178 64.1484 218.815C63.5523 219.452 63.5858 220.452 64.2231 221.048Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M74.5355 207.841C74.5355 207.841 74.4903 207.758 74.461 207.731C74.4318 207.703 74.3885 207.676 74.3456 207.664C74.0177 207.59 72.5694 207.44 69.2457 209.603C69.2886 209.616 69.3246 209.636 69.3538 209.663C69.3903 209.697 69.4127 209.732 69.4283 209.774C69.61 210.341 70.233 214.374 58.4976 226.921C51.6531 234.239 45.4334 239.294 41.1228 242.409C40.4494 243.642 40.1397 244.324 40.1397 244.324L40.2346 244.413C40.2346 244.413 50.8449 238.632 63.6117 224.981C75.347 212.434 74.7172 208.408 74.5423 207.834L74.5355 207.841Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3305 217.068C64.5726 217.295 64.9522 217.282 65.1786 217.04C65.405 216.798 65.3923 216.418 65.1502 216.192C64.9082 215.966 64.5285 215.978 64.3022 216.22C64.0758 216.462 64.0885 216.842 64.3305 217.068Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5812 217.517C66.787 217.709 67.1097 217.698 67.3021 217.493C67.4945 217.287 67.4837 216.964 67.278 216.772C67.0723 216.579 66.7495 216.59 66.5571 216.796C66.3647 217.002 66.3755 217.324 66.5812 217.517Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.959 212.166C59.3291 216.663 54.7615 222.249 50.3882 227.935C54.1751 221.851 58.8998 216.097 64.959 212.166Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M79.4507 226.829C79.4507 226.829 81.931 221.659 78.5396 222.855C75.1482 224.05 76.6637 224.729 71.4574 227.294C66.251 229.859 68.2872 231.298 65.7605 233.385C63.2337 235.472 62.8249 232.556 60.9177 232.224C59.0105 231.891 56.8274 231.561 55.8836 233.17C54.9399 234.78 65.3514 239.137 65.3514 239.137L79.4434 226.822L79.4507 226.829Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6178 232.5C62.9365 232.798 63.4364 232.781 63.7344 232.462C64.0325 232.144 64.0157 231.644 63.6971 231.346C63.3784 231.048 62.8785 231.064 62.5805 231.383C62.2824 231.702 62.2992 232.202 62.6178 232.5Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1074 227.538C67.2123 227.636 67.3768 227.631 67.4749 227.526C67.573 227.421 67.5675 227.257 67.4626 227.159C67.3577 227.06 67.1932 227.066 67.0951 227.171C66.997 227.276 67.0025 227.44 67.1074 227.538Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9227 206.53L83.8371 205.875L84.1501 205.291C84.2966 205.017 84.0733 204.685 83.7633 204.724L83.1081 204.809L82.5246 204.496C82.2508 204.35 81.9187 204.573 81.9574 204.883L82.043 205.538L81.7299 206.122C81.5834 206.396 81.8068 206.728 82.1168 206.689L82.7719 206.604L83.3555 206.917C83.6292 207.063 83.9613 206.84 83.9227 206.53Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6538 205.604C79.9402 205.872 80.3895 205.857 80.6573 205.571C80.9252 205.284 80.9102 204.835 80.6238 204.567C80.3374 204.299 79.8881 204.314 79.6202 204.601C79.3524 204.887 79.3674 205.336 79.6538 205.604Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0449 255.293C29.6217 255.833 30.5266 255.802 31.0661 255.226C31.6055 254.649 31.5753 253.744 30.9985 253.204C30.4217 252.665 29.5168 252.695 28.9773 253.272C28.4378 253.849 28.4681 254.754 29.0449 255.293Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8934 252.599C31.091 252.784 31.4011 252.774 31.586 252.576C31.7708 252.378 31.7605 252.068 31.5628 251.884C31.3652 251.699 31.0551 251.709 30.8702 251.907C30.6854 252.104 30.6958 252.414 30.8934 252.599Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7928 243.818C36.3172 244.309 37.1398 244.281 37.6303 243.757C38.1207 243.232 38.0932 242.41 37.5688 241.919C37.0445 241.429 36.2218 241.456 35.7314 241.981C35.2409 242.505 35.2684 243.328 35.7928 243.818Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.703 243.739C33.8725 243.898 34.1382 243.889 34.2967 243.719C34.4551 243.55 34.4462 243.284 34.2768 243.126C34.1074 242.967 33.8416 242.976 33.6832 243.146C33.5248 243.315 33.5336 243.581 33.703 243.739Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4582 247.085C43.6115 247.228 43.852 247.22 43.9953 247.067C44.1387 246.914 44.1306 246.673 43.9774 246.53C43.8241 246.387 43.5836 246.395 43.4403 246.548C43.2969 246.701 43.3049 246.942 43.4582 247.085Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5959 248.168C42.6927 248.259 42.8446 248.254 42.9352 248.157C43.0257 248.06 43.0206 247.908 42.9238 247.818C42.827 247.727 42.6751 247.732 42.5846 247.829C42.4941 247.926 42.4991 248.078 42.5959 248.168Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6536 199.044C86.55 202.689 92.663 202.484 96.3073 198.588C99.9516 194.691 99.7472 188.578 95.8508 184.934C91.9543 181.29 85.8414 181.494 82.1971 185.391C78.5528 189.287 78.7572 195.4 82.6536 199.044Z",
    fill: "#E6E6E6",
    stroke: "#3F3D56",
    strokeWidth: 0.74,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9819 198.708C86.7089 202.194 92.5561 201.998 96.042 198.271C99.5278 194.544 99.3323 188.697 95.6053 185.211C91.8783 181.725 86.0311 181.921 82.5453 185.648C79.0594 189.375 79.2549 195.222 82.9819 198.708Z",
    stroke: "#04DAF6",
    strokeWidth: 0.51,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2924 186.571C94.5546 186.816 94.9659 186.803 95.2111 186.54C95.4563 186.278 95.4426 185.867 95.1804 185.622C94.9182 185.377 94.5069 185.39 94.2617 185.652C94.0165 185.915 94.0302 186.326 94.2924 186.571Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2947 198.329C83.5569 198.575 83.9682 198.561 84.2135 198.299C84.4587 198.037 84.4449 197.625 84.1827 197.38C83.9205 197.135 83.5092 197.149 83.264 197.411C83.0188 197.673 83.0325 198.084 83.2947 198.329Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6729 197.949C94.9351 198.194 95.3464 198.181 95.5916 197.918C95.8368 197.656 95.8231 197.245 95.5609 197C95.2987 196.754 94.8874 196.768 94.6422 197.03C94.397 197.293 94.4107 197.704 94.6729 197.949Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9144 186.952C83.1765 187.197 83.5879 187.183 83.8331 186.921C84.0783 186.659 84.0645 186.247 83.8024 186.002C83.5402 185.757 83.1288 185.771 82.8836 186.033C82.6384 186.295 82.6522 186.706 82.9144 186.952Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.836 192.181C97.0982 192.426 97.5095 192.413 97.7547 192.15C97.9999 191.888 97.9862 191.477 97.724 191.232C97.4618 190.986 97.0505 191 96.8053 191.262C96.56 191.525 96.5738 191.936 96.836 192.181Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7513 192.719C81.0134 192.964 81.4248 192.951 81.67 192.688C81.9152 192.426 81.9015 192.015 81.6393 191.77C81.3771 191.524 80.9658 191.538 80.7205 191.8C80.4753 192.063 80.4891 192.474 80.7513 192.719Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0625 200.493C89.3247 200.738 89.7361 200.724 89.9813 200.462C90.2265 200.2 90.2127 199.788 89.9506 199.543C89.6884 199.298 89.277 199.312 89.0318 199.574C88.7866 199.836 88.8004 200.247 89.0625 200.493Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5247 184.408C88.7869 184.653 89.1982 184.639 89.4434 184.377C89.6886 184.115 89.6749 183.703 89.4127 183.458C89.1505 183.213 88.7392 183.227 88.494 183.489C88.2488 183.751 88.2625 184.162 88.5247 184.408Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8189 196.729C87.4367 199.177 91.5437 199.04 93.9921 196.422C96.4405 193.804 96.3031 189.698 93.6853 187.249C91.0676 184.801 86.9606 184.938 84.5122 187.556C82.0638 190.174 82.2012 194.281 84.8189 196.729Z",
    fill: "#3F3D56",
    stroke: "#3F3D56",
    strokeWidth: 0.59,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5375 188.402L83.0107 190.259C82.705 191.274 82.6561 192.351 82.8534 193.384L95.6681 191.322C95.5346 190.293 95.1614 189.287 94.5375 188.402Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7158 191.9L82.9928 193.953C83.0569 194.177 83.1351 194.401 83.227 194.61L95.7038 192.601C95.7172 192.367 95.7238 192.141 95.7158 191.9Z",
    fill: "#00FF9F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M91.521 196.576C86.0929 195.894 83.9518 196.397 82.3807 192.997C81.3892 190.851 81.1724 188.389 81.1428 186.869C78.8443 190.703 79.4375 195.749 82.8409 198.932C86.6387 202.484 92.5433 202.393 96.2291 198.788C95.4337 197.853 94.015 196.896 91.5142 196.583L91.521 196.576Z",
    fill: "#272735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.781 192.599C111.172 191.185 111.47 189.725 111.675 188.247C108.191 187.083 105.4 184.664 100.554 180.228C95.9488 176.016 92.5556 171.021 91.945 169.478C90.5187 169.774 89.1088 170.139 87.7447 170.602C89.1798 173.108 92.8049 178.69 97.6913 183.273C102.928 188.171 106.67 190.904 110.767 192.6L110.781 192.599Z",
    fill: "#BD00FF",
    stroke: "#3F3D56",
    strokeWidth: 0.37,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.39,
    d: "M99.0853 181.798C94.7663 177.471 91.0744 172.854 89.3573 170.166C88.7967 170.326 88.236 170.487 87.6836 170.682C88.931 172.862 91.9145 177.24 95.868 181.431C96.462 182.055 97.0632 182.686 97.6854 183.309C101.77 187.389 106.609 190.998 110.713 192.686C110.864 192.144 111.002 191.601 111.118 191.053C107.215 189.223 102.899 185.625 99.0784 181.805L99.0853 181.798Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1023_10279",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.415 62.1232) scale(155.13 155.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#CEAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#D7A82E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F09D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FC9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FB992A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FB993E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FB994C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FB9954"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FB9A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F17426"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1023_10279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.53,
    height: 131.94,
    fill: "white",
    transform: "translate(90.1354 149) rotate(43.085)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenus);
export default __webpack_public_path__ + "static/media/venus.103911962012b4841e408cdb21e2a875.svg";
export { ForwardRef as ReactComponent };